import { deleteField, doc } from 'firebase/firestore';

export function assistantRunExpiryMillis(block) {
  const lease = block.assistant_run_lease;
  if (lease == null) return 0;
  const expiresAt = lease.expires_at?.toMillis?.();
  // A malformed ownership record must not enable publication.
  if (!lease.turn_id || !lease.session_id || !Number.isFinite(expiresAt)) return Infinity;
  return expiresAt;
}

export async function invalidateAssistantRuns(transaction, functionRef, functionData, sessionId) {
  if (!sessionId) return;
  const blockIds = [...new Set((functionData.nodes || [])
    .filter(node => node.data?.type === 'logic')
    .map(node => node.data.blockId))];
  const snapshots = await Promise.all(blockIds.map(blockId =>
    transaction.get(doc(functionRef, 'blocks', blockId))));
  // Complete every read before queuing writes in the editor transaction.
  snapshots.forEach(snapshot => {
    if (!snapshot.exists()) return;
    const lease = snapshot.data().assistant_run_lease;
    if (lease?.session_id !== sessionId) return;
    transaction.update(snapshot.ref, {
      assistant_run_lease: null,
      sandbox_id: deleteField(),
      sandbox_created_at: deleteField(),
      scratch_context_id: deleteField(),
    });
  });
}
